import React from 'react';
import Translate from 'react-translate-component';

import CustomIcon from 'components/common/CustomIcon';

export const DefinitionHeader = ({ translate, children, iconType, addContent }) => (
    <div className="sub-header">
        <CustomIcon type={iconType} />
        { children || <Translate content={translate} fallback={translate} component="span" /> }
        { addContent }
    </div>
);
